module.exports = __webpack_public_path__ + "img/icon-group9.c99ee258.png";